/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestCrazyGames';
import { FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlay';
import { FxIdWebFeaturesStoreCreatePaymentRequestSteamFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestSteamToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestSteam';
import { FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatform';
import { FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeFromJSON, FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerEmbeddingType';
import { FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGames';
import { FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestPlutus';
import { FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSON, FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSON, } from './FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayload';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreCreatePaymentRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreCreatePaymentRequest(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('WebPublishingPlatform' in value) || value['WebPublishingPlatform'] === undefined)
        return false;
    if (!('EmbeddingType' in value) || value['EmbeddingType'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreCreatePaymentRequestFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'Sku': json['Sku'],
        'Token': json['Token'],
        'Currency': json['Currency'] == null ? undefined : json['Currency'],
        'Country': json['Country'] == null ? undefined : json['Country'],
        'CountryHint': json['CountryHint'] == null ? undefined : json['CountryHint'],
        'RedirectUrl': json['RedirectUrl'] == null ? undefined : json['RedirectUrl'],
        'RedirectOnErrorUrl': json['RedirectOnErrorUrl'] == null ? undefined : json['RedirectOnErrorUrl'],
        'DeveloperPayload': json['DeveloperPayload'] == null ? undefined : FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadFromJSON(json['DeveloperPayload']),
        'ProductNameHint': json['ProductNameHint'] == null ? undefined : json['ProductNameHint'],
        'ProductDescriptionHint': json['ProductDescriptionHint'] == null ? undefined : json['ProductDescriptionHint'],
        'WebPublishingPlatform': FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformFromJSON(json['WebPublishingPlatform']),
        'VkontaktePlay': json['VkontaktePlay'] == null ? undefined : FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayFromJSON(json['VkontaktePlay']),
        'AbsoluteGames': json['AbsoluteGames'] == null ? undefined : FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesFromJSON(json['AbsoluteGames']),
        'CrazyGames': json['CrazyGames'] == null ? undefined : FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesFromJSON(json['CrazyGames']),
        'Steam': json['Steam'] == null ? undefined : FxIdWebFeaturesStoreCreatePaymentRequestSteamFromJSON(json['Steam']),
        'EmbeddingType': FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeFromJSON(json['EmbeddingType']),
        'Plutus': json['Plutus'] == null ? undefined : FxIdWebFeaturesStoreCreatePaymentRequestPlutusFromJSON(json['Plutus']),
    };
}
export function FxIdWebFeaturesStoreCreatePaymentRequestToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'Sku': value['Sku'],
        'Token': value['Token'],
        'Currency': value['Currency'],
        'Country': value['Country'],
        'CountryHint': value['CountryHint'],
        'RedirectUrl': value['RedirectUrl'],
        'RedirectOnErrorUrl': value['RedirectOnErrorUrl'],
        'DeveloperPayload': FxIdWebFeaturesStoreCreatePaymentRequestDeveloperPayloadToJSON(value['DeveloperPayload']),
        'ProductNameHint': value['ProductNameHint'],
        'ProductDescriptionHint': value['ProductDescriptionHint'],
        'WebPublishingPlatform': FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformToJSON(value['WebPublishingPlatform']),
        'VkontaktePlay': FxIdWebFeaturesStoreCreatePaymentRequestVkontaktePlayToJSON(value['VkontaktePlay']),
        'AbsoluteGames': FxIdWebFeaturesStoreCreatePaymentRequestAbsoluteGamesToJSON(value['AbsoluteGames']),
        'CrazyGames': FxIdWebFeaturesStoreCreatePaymentRequestCrazyGamesToJSON(value['CrazyGames']),
        'Steam': FxIdWebFeaturesStoreCreatePaymentRequestSteamToJSON(value['Steam']),
        'EmbeddingType': FxIdApplicationStoreCreatePaymentHandlerEmbeddingTypeToJSON(value['EmbeddingType']),
        'Plutus': FxIdWebFeaturesStoreCreatePaymentRequestPlutusToJSON(value['Plutus']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequest.js.map